import { render } from "./mygoodorder.vue?vue&type=template&id=7ca55e2f&scoped=true"
import script from "./mygoodorder.vue?vue&type=script&lang=js"
export * from "./mygoodorder.vue?vue&type=script&lang=js"

import "./mygoodorder.vue?vue&type=style&index=0&id=7ca55e2f&lang=scss"
import "./mygoodorder.vue?vue&type=style&index=1&id=7ca55e2f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ca55e2f"]])

export default __exports__